import React from 'react';
import s from './sliderLoader.module.scss'

const SliderLoader = ({}) => {

    return (
        <div className={s.loaderContainer}>
            <div className={s.loaderBar}></div>
        </div>
    )
}

export default SliderLoader;